<div class="drops-page">
  <div class="drops-header">
    <h1>Drops</h1>
    <mat-button-toggle-group [value]="filter" (change)="filter = $event.value">
      <mat-button-toggle value="upcoming">Upcoming</mat-button-toggle>
      <mat-button-toggle value="all">All</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <div class="progress-spinner" *ngIf="loading"><mat-spinner></mat-spinner></div>
  <p class="error-text" *ngIf="error">{{ error }}</p>

  <div class="drop-grid" *ngIf="!loading">
    <mat-card *ngFor="let drop of visibleDrops">
      <img [src]="drop.imageUrl" [alt]="drop.title" />
      <mat-card-content>
        <h2>{{ drop.title }}</h2>
        <p class="muted">{{ drop.styleId }}</p>
        <p class="muted">
          <button type="button" class="count-link" (click)="openSelections(drop)">
            {{ drop.membersSelected || 0 }}
            {{ (drop.membersSelected || 0) === 1 ? 'member selected' : 'members selected' }}
          </button>
        </p>
        <p>
          {{ drop.releaseDate }}
          <span *ngIf="daysLabel(drop)"> · {{ daysLabel(drop) }}</span>
        </p>
        <p class="mismatch" *ngIf="releaseMismatch(drop)">GOAT release {{ drop.goatReleaseDate }}</p>
        <div class="listed-price">
          <label>
            Listed
            <input type="number" min="1" step="1" [(ngModel)]="drop.editValue" [disabled]="drop.savingValue" />
          </label>
          <button mat-button (click)="saveListedValue(drop)" [disabled]="drop.savingValue || !listedValueChanged(drop)">
            Save
          </button>
          <span class="live" *ngIf="drop.currentValue != null" [class.mismatch]="valueMismatch(drop)">
            Live {{ drop.currentValue | currency:'USD':'symbol':'1.0-0' }}
          </span>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <button mat-button (click)="openInsight(drop)" [disabled]="!drop.insight">Insights</button>
        <button mat-icon-button (click)="confirmDelete(drop)" [disabled]="saving" aria-label="Delete drop">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-card-actions>
    </mat-card>
    <p *ngIf="visibleDrops.length === 0">No drops in this view.</p>
  </div>

  <h2 *ngIf="!loading">Suggested drops</h2>
  <p class="muted" *ngIf="!loading">{{ suggestionNote }}</p>

  <form class="suggestion-search" *ngIf="!loading" (ngSubmit)="searchShoes()">
    <label>
      Find a shoe
      <input
        type="search"
        name="dropSearch"
        placeholder="Title or style ID"
        [(ngModel)]="searchQuery"
        [disabled]="searching"
      />
    </label>
    <button mat-stroked-button type="submit" [disabled]="searching || (searchQuery || '').trim().length < 2">
      Search
    </button>
  </form>
  <p class="muted" *ngIf="searching">Searching…</p>
  <p class="error-text" *ngIf="searchError">{{ searchError }}</p>
  <ul class="search-results" *ngIf="searchResults.length">
    <li *ngFor="let shoe of searchResults">
      <img class="thumb" [src]="shoe.imageUrl" [alt]="shoe.title" />
      <div>
        <div>{{ shoe.title }}</div>
        <div class="muted">{{ shoe.styleId }}<span *ngIf="shoe.releaseDate"> · {{ shoe.releaseDate }}</span></div>
      </div>
      <button
        mat-button
        type="button"
        (click)="addToSuggestions(shoe)"
        [disabled]="shoe.alreadyListed || suggestionHas(shoe)"
      >
        {{ shoe.alreadyListed ? 'Already a drop' : (suggestionHas(shoe) ? 'On the list' : 'Add to list') }}
      </button>
    </li>
  </ul>

  <table *ngIf="!loading && suggestions.length" role="table">
    <thead>
      <tr>
        <th></th>
        <th>Shoe</th>
        <th>Catalog release</th>
        <th>GOAT release</th>
        <th>Members copped</th>
        <th>Retail</th>
        <th>Market value</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let shoe of suggestions; let i = index">
        <td>{{ i + 1 }}</td>
        <td>
          <img class="thumb" [src]="shoe.imageUrl" [alt]="shoe.title" />
          <div>{{ shoe.title }}</div>
          <div class="muted">{{ shoe.styleId }}</div>
        </td>
        <td>{{ shoe.releaseDate }}</td>
        <td [class.mismatch]="releaseMismatch(shoe)">{{ shoe.goatReleaseDate || 'No date' }}</td>
        <td>{{ shoe.membersCopped }}</td>
        <td>{{ shoe.retailPrice | currency:'USD':'symbol':'1.0-0' }}</td>
        <td>{{ shoe.currentValue != null ? (shoe.currentValue | currency:'USD':'symbol':'1.0-0') : '—' }}</td>
        <td>
          <button mat-stroked-button color="primary" (click)="confirmAdd(shoe)" [disabled]="saving">Add</button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
